var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('print-template',[(_vm.activity)?_c('activity-print',{attrs:{"activity":_vm.activity}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }